<template>
  <div>
    <ys-detail :icon="detailIcon" :loading="loading" :name="detail.checkName">
      <Tag size="medium" color="blue" slot="status">{{ detail.checkStatus|getBaseDataName('专项任务状态') }}</Tag>
      <template slot="brief">
        <ys-cell title="项目名称" :label="detail.projectName"/>
      </template>
      <template slot="main-left">
        <Tabs type="card" v-model="tab">
          <Tab-pane label="位置" icon="md-pin" name="1">
            <div id="container" :style="{height:height-215+'px',margin:'10px 0'}"></div>
          </Tab-pane>
        </Tabs>
      </template>
      <template slot="main-right">
        <h1 class="h1Title">打卡记录</h1>
        <ul class="record" v-for="item in allList" :key="item.id">
        <li>
          <div class="info">
            <p>打卡类型：{{ item.state == 1  ? '签到' : '签退' }}</p>
            <p>位置：{{ item.address }}</p>
            <p>坐标：{{ item.signLat }} - {{ item.signLng }}</p>
            <p>时间：{{ item.signTime }}</p>
          </div>
          <div class="pic">
            <ys-image :src="item.url" :dataSrc="item.url" :width="200" :height="200"></ys-image>
          </div>
        </li>
      </ul>
      </template>
    </ys-detail>
  </div>
</template>

<script>
import detail from '@/mixins/detail.js'
import config from "@/config";
import {transformGCJ2WGS} from "../../../../../ys-admin/src/lib/transformGCJ2WGS";

export default {
  name: '',
  mixins: [detail],
  props: {
    checkId: {
      type: [String, Number],
      default: ''
    },
    userId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      detail: {},
      map: '',
      allList: [],
    }
  },

  mounted() {
    this.getDetail();
  },

  computed: {
    config() {
      return config
    }
  },

  methods: {
    getDetail() {
      if(this.map) this.map = null;
      this.loading = true;
      this.$get('/checkUser/record/List', {checkId: this.checkId, userId: this.userId, limit: -1}).then((res) => {
        this.loading = false
        this.allList = res.data.list.filter(item => item.checkId == this.checkId);
        this.detail = this.allList[0];
        this.setTagName(this.detail.iname);
        setTimeout(() => {
            // 转换坐标
          const data = transformGCJ2WGS(Number(this.detail.signLat), Number(this.detail.signLng))
          const lat = Number(data.lat);
          const lng = Number(data.lon);
          const center = /* eslint-disable */ new T.LngLat(lng, lat);
          this.map = /* eslint-disable */ new T.Map('container')
          this.map.centerAndZoom(center, 16);
          let infoWindow = /* eslint-disable */ new T.InfoWindow("<div><font color='#000000'> " + (this.detail.state == 1 ? '签到地点：' : '签退地点：') + this.detail.address + "</font></div>");
          this.map.openInfoWindow(infoWindow, center); // 开启信息窗口
          this.loading = false
        }, 1000)
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped lang="less">
#container {
  width: 100%;
  height: 500px;
}

.main {
  display: flex;

  .mainLeft {
    width: 70%;
    padding: 8px 20px 0 20px;
    border-right: 10px solid #f4f4f4;
  }

  .mainRight {
    width: 30%;
    padding: 8px 20px 0 20px;
  }
}
.record {
      
      li {
        padding: 10px 0;
        border-bottom: 1px solid #ececec;

        .info {
          padding-left: 10px;
          flex: 1;
          font-size: 12px;
        }
      }
    }

</style>